<template>
  
  <div class="product-content">
    <div class="sysPanel">
    <div class="small-options clearfix">
      <div class="options-item fl">
        <div class="formitems">
          <div class="options-wxchat">上传代码</div>
          <div class="options-version qrimg">
            <span>选择版本上传</span>
          </div>
          <div class="options-btn">
            <a href="javascript:;" @click="chooseCode" class="el-button el-button--primary el-button--small">上传</a>
          </div>
        </div>
      </div>

      <div class="options-item fl">
        <div class="formitems">
          <div class="options-wxchat">体验码</div>
          <div class="options-version"><img v-img-url="image_qrcode" alt="" class="qrimg" /></div>
          <div class="options-btn">
            <a href="javascript:;" @click="getQrcode" class="el-button el-button--primary el-button--small">获取</a>
          </div>
        </div>
      </div>
      <div class="options-item fl">
        <div class="formitems">
          <div class="options-wxchat">提交审核</div>
          <div class="options-version qrimg">
            <span>已上传版本号：</span>
            <span>{{curVersion}}</span>
          </div>
          <div class="options-btn">
            <a href="javascript:;" @click="auditCode" v-if="status==1" class="el-button el-button--primary el-button--small">审核</a>
            
          </div>
        </div>
      </div>
      <div class="options-item fl">
        <div class="formitems">
          <div class="options-wxchat">发布小程序</div>
          <div class="options-version qrimg">
            <span>请等待审核通过之后进行发布</span>
          </div>
          <div class="options-btn">
            <a href="javascript:;" @click="releaseCode" v-if="status==3" class="el-button el-button--primary el-button--small">发布</a>
          </div>
        </div>
      </div>
    </div>
  </div>
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="opt_log_id" label="id" width="70"></el-table-column>
          <el-table-column prop="real_name" label="操作员"></el-table-column>
          <el-table-column prop="title" label="标题"></el-table-column>
           <el-table-column prop="content" label="内容" width="300"></el-table-column>
          <el-table-column prop="ip" label="IP" width="120"></el-table-column>
          <el-table-column prop="browser" label="Browser" width="120"></el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[2, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>

      <!--商品选择-->
    <Version :isversion="isversion" @closeDialog="closeVersionFunc"></Version>
    </div>
</template>
<script>
import PortApi from '@/api/port.js';
import Version from '@/components/version/Version.vue';
export default {
  components: {
    Version
  },
  data() {
    return {
      /*当前选中*/
      activeName: "",
      isversion:false,
      curVersion:'',
      status:0,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      loading:true,
      image_qrcode:'',
    };
  },
  created() {
    /*获取列表*/
    this.port_id = this.$route.query.port_id;
    this.type = this.$route.query.type;
    this.getBaseData();
  },
  methods: {

    getBaseData:function(){
      let self = this;
      let params = {}
      params.port_id = self.port_id;
      params.type = self.type;
      PortApi.getBaseData(params, true)
        .then(res => {
          self.loading = false;
          self.image_qrcode = res.data.qrcodeurl;
          self.curVersion = res.data.port_info.curversion;
          self.status = res.data.port_info.status;
          self.tableData = res.data.optLog.data;
          self.totalDataNumber = res.data.optLog.total;
          Object.assign(self.form, res.data);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*提交*/
    onSubmit: function() {
      let self = this;
      let params = self.form.model;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          params.alone_grade_equity=self.convertJson(self.form.gradeList);
          PorductApi.addProduct(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    chooseCode:function(){
      this.isversion = true;
    },
    /* 提交审核 */
    auditCode:function(){
      let self = this;
      let params = {}
      params.port_id = self.port_id;
      params.type = self.type;
      PortApi.auditCode(params, true)
        .then(res => {
          self.loading = false;
          self.$message({
            message: '提交审核成功',
            type: 'success'
          });
          this.$router.push({
            path:"/plus/port/manager/index",
            query:{
              'port_id':self.port_id,
              'type':self.type
            }
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭版本选择*/
    closeVersionFunc(e) {
      this.isversion = false;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    //获取体验码
    getQrcode:function(){
      let self = this;
      let params = {};
      params.port_id = self.port_id;
      params.type = self.type;
      PortApi.getQrcode(params,true)
      .then(data => {
        self.loading = false;
        self.image_qrcode = data.data.qrcodeurl
        self.$message({
          message: '获取成功',
          type: 'success'
        });
      })
      .catch(error => {
        self.loading = false;
      })
    },

    /* 发布代码 */
    releaseCode:function(){
      let self = this;
      let params = {};
      params.port_id = self.port_id;
      params.type = self.type;
      PortApi.releaseCode(params,true)
      .then(data => {
        self.loading = false;
        self.$message({
          message: data.msg,
          type: 'success'
        });
      })
      .catch(error => {
        self.loading = false;
      })
    },


    /* 提交代码 */

    submitCode:function(){
      let self = this;
      let params = {};
      params.port_id = self.port_id;
      params.type = self.type;
      PortApi.submitCode(params,true)
      .then(data => {
        self.loading = false;
        self.$message({
          message: '添加成功',
          type: 'success'
        });
      })
      .catch(error => {
        self.loading = false;
      })
    }
  },
};
</script>

<style>
.sysPanel {
  position: relative;
  padding: 10px 20px;
  background: #f8f8f8;
  margin-bottom: 10px;
}
.small-options {
  width: 100%;
}
.options-item {
  width: calc(25% - 1px);
  text-align: center;
  border-right: 1px solid #ccc;
}
.formitems {
  line-height: 40px;
  padding: 0 0 8px;
}
.options-btn {
  padding: 10px 0;
}
.qrimg{
  width: 100px;
  height: 100px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/port/manager/codemanager/index.vue